import { Reveal } from "@/lib/motion";
import { Section } from "./primitives";
import { DOC_CONFIG } from "@/config/site";
import { FileText, Download, ArrowUpRight } from "lucide-react";

export default function WhitepaperSection() {
  return (
    <Section id="whitepaper">
      <Reveal className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-xl sm:p-14">
        <div className="pointer-events-none absolute inset-0 grid-bg opacity-30" />
        <div className="pointer-events-none absolute -left-20 top-0 h-64 w-64 rounded-full bg-indigo-600/15 blur-[100px]" />

        <div className="relative grid gap-10 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-3">
              <span className="h-px w-8 bg-indigo-500/60" />
              <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-indigo-300">Whitepaper</span>
            </div>
            <h2 className="mt-6 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
              Explore the Full Vision
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-gray-400 sm:text-lg">
              Explore the technical architecture, tokenomics, governance framework, security
              principles and long-term vision behind XVPR.
            </p>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-4">
            <a
              href={DOC_CONFIG.whitepaperUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between gap-3 rounded-full bg-white px-7 py-4 font-mono text-sm font-bold uppercase tracking-[0.14em] text-black transition-all hover:bg-indigo-400 hover:text-white"
              data-testid="read-whitepaper-button"
            >
              <span className="flex items-center gap-2">
                <FileText className="h-4 w-4" />
                Read Whitepaper
              </span>
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href={DOC_CONFIG.whitepaperPdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between gap-3 rounded-full border border-white/20 px-7 py-4 font-mono text-sm font-bold uppercase tracking-[0.14em] text-white transition-all hover:border-white/50 hover:bg-white/5"
              data-testid="download-pdf-button"
            >
              <span className="flex items-center gap-2">
                <Download className="h-4 w-4" />
                Download PDF
              </span>
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
      </Reveal>
    </Section>
  );
}
